const actions = {
  CHECK_LOGIN_TYPE_REQUEST: 'CHECK_LOGIN_TYPE_REQUEST',
  CHECK_LOGIN_TYPE_SUCCESS: 'CHECK_LOGIN_TYPE_SUCCESS',
  CHECK_LOGIN_TYPE_ERROR: 'CHECK_LOGIN_TYPE_ERROR',
  CHECK_LOGIN_METHODS_REQUEST: 'CHECK_LOGIN_METHODS_REQUEST',
  CHECK_LOGIN_METHODS_SUCCESS: 'CHECK_LOGIN_METHODS_SUCCESS',
  CHECK_LOGIN_METHODS_ERROR: 'CHECK_LOGIN_METHODS_ERROR',
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  CHECK_AUTHORIZATION_SUCCESS: 'CHECK_AUTHORIZATION_SUCCESS',
  CHECK_CREATE_PASSWORD_TOKEN_FAIL: 'CHECK_CREATE_PASSWORD_TOKEN_FAIL',
  CHECK_CREATE_PASSWORD_TOKEN_REQUEST: 'CHECK_CREATE_PASSWORD_TOKEN_REQUEST',
  CHECK_CREATE_PASSWORD_TOKEN_SUCCESS: 'CHECK_CREATE_PASSWORD_TOKEN_SUCCESS',
  CHECK_RESET_PASSWORD_TOKEN_FAIL: 'CHECK_RESET_PASSWORD_TOKEN_FAIL',
  CHECK_RESET_PASSWORD_TOKEN_REQUEST: 'CHECK_RESET_PASSWORD_TOKEN_REQUEST',
  CHECK_RESET_PASSWORD_TOKEN_SUCCESS: 'CHECK_RESET_PASSWORD_TOKEN_SUCCESS',
  CREATE_PASSWORD_FAIL: 'CREATE_PASSWORD_FAIL',
  CREATE_PASSWORD_REQUEST: 'CREATE_PASSWORD_REQUEST',
  CREATE_PASSWORD_SUCCESS: 'CREATE_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAIL: 'RESET_PASSWORD_FAIL',
  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  SEND_CONFIRMATION_FAIL: 'SEND_CONFIRMATION_FAIL',
  SEND_CONFIRMATION_REQUEST: 'SEND_CONFIRMATION_REQUEST',
  SEND_CONFIRMATION_SUCCESS: 'SEND_CONFIRMATION_SUCCESS',
  SET_STEP: 'SET_STEP',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  GOOGLE_REQUEST: 'GOOGLE_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FROM_UNIFIED_LOGIN: 'LOGOUT_FROM_UNIFIED_LOGIN',
  LOGOUT_FROM_UNIFIED_LOGIN_SUCCESS: 'LOGOUT_FROM_UNIFIED_LOGIN_SUCCESS',
  LOGOUT_FROM_UNIFIED_LOGIN_ERROR: 'LOGOUT_FROM_UNIFIED_LOGIN_ERROR',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  UPDATE_SELECTED_COUNTRY_REQUEST: 'UPDATE_SELECTED_COUNTRY_REQUEST',
  UPDATE_SELECTED_COUNTRY_SUCCESS: 'UPDATE_SELECTED_COUNTRY_SUCCESS',
  UPDATE_SELECTED_TIMEZONE: 'UPDATE_SELECTED_TIMEZONE',
  CLEAR_ERROR: 'CLEAR_ERROR',
  UPDATE_PROFILE_AVATAR: 'UPDATE_PROFILE_AVATAR',
  UPDATE_PROFILE: 'UPDATE_PROFILE',
  CHANGE_PROPERTY: 'CHANGE_PROPERTY',

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  checkLoginTypeRequest: payload => ({
    type: actions.CHECK_LOGIN_TYPE_REQUEST,
    payload,
  }),

  checkLoginTypeSuccess: payload => ({
    type: actions.CHECK_LOGIN_TYPE_SUCCESS,
    payload,
  }),

  checkLoginTypeError: payload => ({
    type: actions.CHECK_LOGIN_TYPE_ERROR,
    payload,
  }),

  checkLoginMethodsRequest: () => ({
    type: actions.CHECK_LOGIN_METHODS_REQUEST,
  }),

  checkLoginMethodsSuccess: payload => ({
    type: actions.CHECK_LOGIN_METHODS_SUCCESS,
    payload,
  }),

  checkLoginMethodsError: payload => ({
    type: actions.CHECK_LOGIN_METHODS_ERROR,
    payload,
  }),

  updateSelectedCountryRequest: data => ({
    type: actions.UPDATE_SELECTED_COUNTRY_REQUEST,
    payload: data,
  }),

  updateSelectedCountrySuccess: data => ({
    type: actions.UPDATE_SELECTED_COUNTRY_SUCCESS,
    payload: data,
  }),

  updateSelectedTimezone: data => ({
    type: actions.UPDATE_SELECTED_TIMEZONE,
    payload: data,
  }),

  checkAuthorization: () => ({
    type: actions.CHECK_AUTHORIZATION,
  }),

  checkAuthorizationSuccess: () => ({
    type: actions.CHECK_AUTHORIZATION_SUCCESS,
  }),

  createPassword: data => ({
    type: actions.CREATE_PASSWORD_REQUEST,
    payload: data,
  }),

  sendConfirmationEmail: data => ({
    type: actions.SEND_CONFIRMATION_REQUEST,
    payload: data,
  }),

  resetPassword: data => ({
    type: actions.RESET_PASSWORD_REQUEST,
    payload: data,
  }),

  setStep: data => ({
    type: actions.SET_STEP,
    payload: data,
  }),

  checkCreatePasswordToken: data => ({
    type: actions.CHECK_CREATE_PASSWORD_TOKEN_REQUEST,
    payload: data,
  }),

  checkResetPasswordToken: data => ({
    type: actions.CHECK_RESET_PASSWORD_TOKEN_REQUEST,
    payload: data,
  }),

  googleLoginRequest: data => ({
    type: actions.GOOGLE_REQUEST,
    payload: data,
  }),

  loginError: data => ({
    type: actions.LOGIN_ERROR,
    payload: data,
  }),

  login: data => ({
    type: actions.LOGIN_REQUEST,
    payload: data,
  }),

  loginSuccess: data => ({
    type: actions.LOGIN_SUCCESS,
    payload: data,
  }),

  logout: data => ({
    type: actions.LOGOUT,
    payload: data,
  }),

  logoutSuccess: data => ({
    type: actions.LOGOUT_SUCCESS,
    payload: data,
  }),

  logoutFromUnifiedLogin: data => ({
    type: actions.LOGOUT_FROM_UNIFIED_LOGIN,
    payload: data,
  }),

  logoutFromUnifiedLoginSuccess: () => ({
    type: actions.LOGOUT_FROM_UNIFIED_LOGIN_SUCCESS,
  }),

  logoutFromUnifiedLoginError: () => ({
    type: actions.LOGOUT_FROM_UNIFIED_LOGIN_ERROR,
  }),

  clearError: () => ({
    type: actions.CLEAR_ERROR,
  }),

  updateProfileAvatar: data => ({
    type: actions.UPDATE_PROFILE_AVATAR,
    payload: data,
  }),

  updateProfile: data => ({
    type: actions.UPDATE_PROFILE,
    payload: data,
  }),
};
export default actions;
